import React from 'react';

import viewIcon from 'images/icons/invite/view.svg';
import downloadIcon from 'images/icons/invite/download.svg';
import payIcon from 'images/icons/invite/cash.svg';

import Tooltip from 'components/ui/Tooltip';
import { useContext } from '../Context';

export default function Actions({ row }) {
  const { dispatch, actions, state } = useContext();

  const payInvoice = (e) => {
    swal(
      {
        title: '',
        text: 'Would you like to mark this invoice paid?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Approve',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      (isConfirm) => {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== 'A') {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';

          actions.pay(dispatch, row.id);
        }
      },
    );
  };

  return (
    <>
      <div>
        {row.attributes.status == 'open' && (
          <a
            data-tip="Mark as Paid"
            onClick={payInvoice}
            className="mr5"
            target="_blank"
          >
            <img src={payIcon} />
          </a>
        )}
        {row.attributes.status != 'draft' && (
          <>
            <a
              data-tip="View"
              href={row.attributes.invoice_link}
              className="mr5"
              target="_blank"
              rel="noreferrer"
            >
              <img src={viewIcon} />
            </a>
            <a
              data-tip="Download"
              href={row.attributes.invoice_pdf}
              target="_blank"
              rel="noreferrer"
            >
              <img src={downloadIcon} />
            </a>
          </>
        )}
      </div>
      <Tooltip />
    </>
  );
}
